import { useEffect, useMemo, useState } from "react";
import { getPersonaManagement } from "../services/FetchAPI";

const mapPersonaToSelectOptions = (personaList) =>
  personaList.map((persona) => ({
    value: persona.user_group_id,
    label: persona.persona_name,
  }));

const buildPersonaMap = (personaList) => {
  const map = {};
  personaList.forEach((persona) => {
    map[persona.user_group_id] = persona.persona_name;
  });
  return map;
};

export default function usePersonaManagement(passtoken) {
  const [personaList, setPersonaList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!passtoken) {
      setLoading(false);
      return;
    }

    let isMounted = true;

    const fetchPersonas = async () => {
      setLoading(true);
      try {
        const data = await getPersonaManagement(passtoken);
        if (isMounted) {
          setPersonaList(Array.isArray(data) ? data : []);
          setError(null);
        }
      } catch (err) {
        if (isMounted) {
          setError(err);
          setPersonaList([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchPersonas();

    return () => {
      isMounted = false;
    };
  }, [passtoken]);

  const personaOptions = useMemo(
    () => mapPersonaToSelectOptions(personaList),
    [personaList]
  );

  const personaMap = useMemo(
    () => buildPersonaMap(personaList),
    [personaList]
  );

  const getPersonaLabel = (userGroupId) =>
    personaMap[userGroupId] ?? String(userGroupId);

  return {
    personaList,
    personaOptions,
    personaMap,
    getPersonaLabel,
    loading,
    error,
  };
}
